// Mirrors utils/vendorContracts/constants.js on the server. Labels are dashboard keys.
export const CATEGORY_LABELS = {
  mobile: "Mobile phone",
  internet_landline: "Internet & landline",
  vehicle_leasing: "Vehicle leasing",
  vehicle_financing: "Vehicle financing",
  vehicle_insurance: "Vehicle insurance",
  insurance: "Insurance",
  energy: "Electricity & gas",
  rent: "Rent",
  software: "Software & subscriptions",
  equipment_leasing: "Equipment leasing",
  maintenance: "Maintenance & service",
  banking: "Bank & payments",
  other: "Other"
};

export const CATEGORY_COLORS = {
  mobile: "blue",
  internet_landline: "geekblue",
  vehicle_leasing: "purple",
  vehicle_financing: "purple",
  vehicle_insurance: "magenta",
  insurance: "magenta",
  energy: "gold",
  rent: "orange",
  software: "cyan",
  equipment_leasing: "lime",
  maintenance: "green",
  banking: "volcano",
  other: "default"
};

export const BILLING_INTERVAL_LABELS = {
  monthly: "Monthly",
  quarterly: "Quarterly",
  half_yearly: "Half-yearly",
  yearly: "Yearly",
  one_time: "One-time",
  unknown: "Unknown"
};

export const PRICE_BASIS_LABELS = { gross: "Gross", net: "Net (plus VAT)", unknown: "Unknown" };

export const RENEWAL_LABELS = {
  renews: "Renews automatically for a fixed period",
  indefinite: "Continues, cancellable at any time",
  ends: "Ends automatically",
  unknown: "Unknown"
};

export const NOTICE_UNIT_LABELS = { days: "Days", weeks: "Weeks", months: "Months" };

export const NOTICE_TO_LABELS = {
  end_of_term: "To the end of the term",
  end_of_month: "To the end of a month",
  any_day: "To any day",
  unknown: "Unknown"
};

export const STATUS_LABELS = { active: "Active", cancelled: "Cancelled", ended: "Ended" };

export const formatMoney = (value, lng, currency = "EUR") =>
  value === null || value === undefined
    ? "–"
    : new Intl.NumberFormat(lng || "de", { style: "currency", currency }).format(value);

// Contract dates are calendar days ("YYYY-MM-DD"). Parsed as local dates, or new Date()
// would read them as UTC midnight and show the day before west of Greenwich.
export const formatDay = (value, lng) => {
  if (!value) return "–";
  const [year, month, day] = value.split("-").map(Number);
  return new Intl.DateTimeFormat(lng || "de", { dateStyle: "medium" }).format(
    new Date(year, month - 1, day)
  );
};
